
export default function miniPackages(window, requirejs, isServerSide) {
  const { location: { hostname } = {} } = window

  // Prefetch font CSS files
  // By marking them as media="none" their download is made non-blocking
  // (At least for WebKit / Blink browsers)
  // (WixThemeReact may remove this attribute)
  if (!isServerSide && hostname !== 'localhost') {
    requirejs([
      'lodash',
      'fonts'
    ], (
      _,
      fonts
    ) => {
      function enableLink() {
        this.removeAttribute('media')
      }

      const { document, rendererModel: { siteInfo: { documentType } }, serviceTopology } = window
      const cssUrls = fonts.fontUtils.getCssUrls(documentType, serviceTopology)
      _.forEach(cssUrls, (url, id) => {
        const link = document.createElement('link')
        link.setAttribute('rel', 'stylesheet')
        link.setAttribute('href', url)
        link.setAttribute('media', 'none')
        link.setAttribute('id', `font_${id}`)
        link.addEventListener('load', enableLink, false)
        document.head.appendChild(link)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./~/santa-main-r/src/main/lib/viewer/miniPackages.js